import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { Field, reduxForm } from 'redux-form';

import RegisterForm from './../../components/register/';
import { postRegistration } from './../../actions/auth/';
import { literals } from './../../languages';

class RegistationScreen extends Component {

  handleRegistrationSubmit = (values) => {
    // alert(JSON.stringify(values));
    this.props.postRegistration(values);
  }

  render () {
    return (
      <div className="form-container">
        <h1 className="form-title">{literals.register[this.props.locale]}</h1>
        <RegisterForm locale={this.props.locale} browserHistory={this.props.history} onSubmit={this.handleRegistrationSubmit} />
        {this.props.isLoading 
          ? <div className="alert alert-info" role="alert">{literals.registrationLoadingMessage[this.props.locale]}</div> 
          : (this.props.error) 
            ? <div className="alert alert-danger" role="alert">{this.props.error}</div> 
            : (this.props.response)
                ? <div className="alert alert-success" role="alert">{this.props.response}</div> 
                : ''
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.authReducer.register.isLoading,
    error: state.authReducer.register.error,
    response: state.authReducer.register.response
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    postRegistration: (values, history, locale) => dispatch(postRegistration(values, props.history, props.locale)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistationScreen);



// WEBPACK FOOTER //
// ./src/screens/RegistrationScreen/index.js